/* eslint-disable */
import _ from "lodash/fp";
import React, { useEffect } from 'react';
import { useForm } from "react-hook-form";
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { SET_STAGE } from '../../../common/constants/ActionTypes';
import { urlRegex } from "../../../common/constants/regex";
import commonLabels from '../../../common/labels/common_en.json';
import { addStageData, editStageData, getStageListPagination, resetStage, resetStageList } from '../actions/masterManagementAction';
import masterLabels from '../labels/master_en.json';
import StageList from './StageList';

const StageForm = ({ addStage, setAddStage, setStageName, stageDescription, setStageDescription, stageName, stageCode, setStageCode, stageType, setStageType, setStageUrl, stageUrl, isExternal, setIsExternal }) => {
  const dispatch = useDispatch();
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange"
  });

  const onSubmit = (data, addStage, setAddStage) => {
    let requestBody = {
      "stageDto": {
        "name": data.stageName,
        "description": data.stageDescription,
        "code": data.stageCode,
        "type": stageType ? stageType : '',
        "url": data.stageUrl,
        "isExternal": data.isExternal,
        "isActive": data.isActive,
        "isDeleted": false
      }
    };
    dispatch(resetStageList());
    if (addStage.Mode == 'Add') {
      dispatch(addStageData(requestBody, setAddStage, setStageName, setStageDescription, setStageCode, setStageType, setStageUrl, setIsExternal));
    }
    else if (addStage.Mode == 'Edit') {
      requestBody.stage.id = addStage.id;
      requestBody.stage.code = stageCode;
      requestBody.stage.type = stageType;

      dispatch(editStageData(requestBody, setAddStage, setStageName, setStageDescription, setStageCode, setStageType, setStageUrl, setIsExternal));
    }
  }

  useEffect(() => {
    if (addStage && addStage.Mode == 'Add') {
      dispatch(resetStageList());
      setStageName('');
      setStageDescription('');
      setStageType('external');
      setStageCode('');
      setStageUrl('');
      setIsExternal(true);
    }
    // dispatch(getAllStagesData());
    // addStage.Mode == "Edit" && addStage.id > 0 && dispatch(getStageData(addStage.id));
    addStage.Mode == "Edit" && addStage.id > 0 && setStageName(addStage.name);
    addStage.Mode == "Edit" && addStage.id > 0 && setStageDescription(addStage.description);
    addStage.Mode == "Edit" && addStage.id > 0 && setStageType(addStage.type);
    addStage.Mode == "Edit" && addStage.id > 0 && setStageCode(addStage.code);
    addStage.Mode == "Edit" && addStage.id > 0 && setStageUrl(addStage.url);
    addStage.Mode == "Edit" && addStage.id > 0 && setIsExternal(addStage.isExternal);

    dispatch({
      type: SET_STAGE,
      payload: {},
    });
    // eslint-disable-next-line
  }, [])


  const onChangeStageName = (e) => {
    setStageName(e.target.value)
  }

  const onChangeStageDescription = (e) => {
    setStageDescription(e.target.value)
  }

  const onChangeStageUrl = (e) => {
    setStageUrl(e.target.value)
  }

  const onChangeStageCode = (e) => {
    setStageCode(e.target.value);
  }

  const onChangeStageType = (e) => {

    setStageType(e.target.value);
    if (e.target.value == 'internal' || e.target.value == '') {
      setIsExternal(false);
    } else {
      setIsExternal(true);
    }
  }

  const onChangeIsExternal = (e) => {

    if (e.target.checked) {
      setIsExternal(true);
    } else {
      setIsExternal(false);
    }

  }

  const { stageData } = useSelector((state) => state.masterManagementReducer, shallowEqual);

  const onCancelButton = () => {
    setStageName('');
    dispatch(resetStage());
    dispatch(resetStageList());
    dispatch(getStageListPagination(0, 10, ''));
    setAddStage({ "Mode": false });
  }

  return addStage.Mode == false ? (
    <div>
      <StageList
        setaddStage={setAddStage}
      />
    </div>
  ) : (
    <div>
      <form>
        <div className="border border-light text-center w-100 p-5" >
          <div className='form-group'>
            <div className='row'>
              <div className='col-md-6'>
                <h4><p className='float-left'>{addStage.Mode == 'Add' ? masterLabels.stageForm.Add_Stage : masterLabels.stageForm.Update_Stage}</p></h4>
              </div>
            </div>
          </div>
          <br />
          <div className='form-group'>
            <div className='row'>
              <div className='col-md-2'>
                <label className='font-weight-bold float-left' >{masterLabels.stageForm.Name}<span className="redColor">*</span></label>
                <input
                  type="text"
                  className="form-control input-sm"
                  name="stageName"
                  placeholder={masterLabels.stageForm.Name}
                  ref={register({ required: true, maxLength: 200 })}
                  defaultValue={addStage && addStage.Mode == 'Edit' && stageData && stageData.stage && stageData.stage.name ? stageData.stage.name : ''}
                  onChange={onChangeStageName}
                />
                {_.get("stageName.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}
                {_.get("stageName.type", errors) === "maxLength" && (
                  <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_200}</p>
                )}
              </div>

              <div className='col-md-2' >
                <label className='font-weight-bold float-left' >{masterLabels.stageForm.StageDescription}<span className="redColor">*</span></label>
                <input type="text"
                  className="form-control"
                  name="stageDescription"
                  value={stageDescription}
                  placeholder={masterLabels.stageForm.StageDescription}
                  defaultValue={addStage && addStage.Mode == 'Edit' && stageData && stageData.stage && stageData.stage.description}
                  ref={register({ required: true, maxLength: 200 })}
                  onChange={onChangeStageDescription}
                />
                {_.get("stageDescription.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}
                {_.get("stageDescription.type", errors) === "maxLength" && (
                  <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_200}</p>
                )}
              </div>
              <div className='col-md-2' >
                <label className='font-weight-bold float-left' >{masterLabels.stageForm.StageCode}<span className="redColor">*</span></label>
                <input type="text"
                  className="form-control"
                  name="stageCode"
                  onChange={onChangeStageCode}
                  value={stageCode}
                  placeholder={masterLabels.stageForm.StageCode}
                  defaultValue={addStage && addStage.Mode == 'Edit' && stageData && stageData.stage && stageData.stage.code}
                  ref={register({ required: true, maxLength: 200 })}

                />
                {_.get("stageCode.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}
                {_.get("stageCode.type", errors) === "maxLength" && (
                  <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_200}</p>
                )}
              </div>
              <div className='col-md-2' >
                <label className='font-weight-bold float-left' >{masterLabels.stageForm.StageType}<span className="redColor">*</span></label>
                <select
                  className="form-control"
                  name="stageType"
                  value={stageType}
                  onInput={onChangeStageType}
                  ref={register({ required: true })}
                  defaultValue={addStage && addStage.Mode == 'Edit' && stageData && stageData.stage && stageData.stage.type}
                >
                  <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                  <option key={1} value="internal">Internal</option>
                  <option key={2} value="external">External</option>
                  <option key={3} value="external_redirect">External Redirect</option>
                </select>
                {_.get("stageType.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}
              </div>
              <div className='col-md-2' >
                <label className='font-weight-bold float-left' >{masterLabels.stageForm.StageUrl}</label>
                <input type="text"
                  className="form-control"
                  name="stageUrl"
                  onChange={onChangeStageUrl}
                  value={stageUrl}
                  placeholder={masterLabels.stageForm.StageUrl}
                  defaultValue={addStage && addStage.Mode == 'Edit' && stageData && stageData.stage && stageData.stage.url}
                  ref={register({ maxLength: 2035, pattern: urlRegex })}
                />

                {_.get("stageUrl.type", errors) === "pattern" && (
                  <p className="errorText float-left">{commonLabels.URL_PATTERN}</p>
                )}
              </div>
              <div className='col-md-1'>
                <label className='font-weight-bold float-left  text-left w-100'>{masterLabels.stageForm.Status}?&nbsp;&nbsp;</label>
                <input
                  className='float-left text-left'
                  type="checkbox"
                  name="isActive"
                  value={true}
                  defaultChecked={stageData && stageData.stage && stageData.stage.isActive}
                  ref={register({})}
                />
              </div>
              <div className='col-md-1'>
                <label className='font-weight-bold float-left  text-left w-100'>{masterLabels.stageForm.IsExternal}?&nbsp;&nbsp;</label>
                <input
                  className='float-left text-left'
                  type="checkbox"
                  name="isExternal"
                  checked={isExternal}
                  value={isExternal}
                  onChange={onChangeIsExternal}
                  defaultChecked={stageData && stageData.stage && stageData.stage.isExternal}
                  ref={register({})}
                />
              </div>
            </div>
            <div className="row mt-5">
              <div className='col-md-10'></div>
              <div className='col-md-2 text-right'>
                <button type="button" className="btn btn-secondary mr-2" onClick={() => onCancelButton()}>
                  {commonLabels.BUTTON_CANCEL}
                </button>
                <button type="submit" className=" btn btn-primary custom_button   " onClick={handleSubmit((e) => { onSubmit(e, addStage, setAddStage); })}>
                  {commonLabels.BUTTON_SAVE}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default StageForm;